<template>
    <section>
      <div class="container has-text-left">
        <a href="" title="MCX bhavcopy"><span class="title is-size-2 has-text-danger">MCX</span>
        <span class="subtitle"> bhavcopy</span></a>
        <br /><br />
        <b-field position="is-left" grouped class="has-text-left">
            <b-field label="Date of Report" custom-css="is-small">
                <b-datepicker v-model="curDate"
                    placeholder="Click to select..."
                    icon="calendar-today"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :mobile-native=false
                    :first-day-of-week=1
                    :unselectable-days-of-week="unselectedDays"
                    @input="getBhavCopy()">
                    <button class="button is-primary"
                    @click="date = new Date()">
                    <b-icon icon="calendar-today"></b-icon>
                    <span>Today</span>
                </button>
                </b-datepicker>
            </b-field>

       <b-field label="Symbol">
        <b-dropdown
            v-model="selectedOptions"
            multiple
            @change="getBhavCopy"
            aria-role="list">
            <button class="button is-outlined" type="button" slot="trigger">
<span v-if="selectedOptions.length>=1">
     <b-tag :key="index" v-for="(symbol, index) in selectedOptions" type="is-primary" size="is-small"> 
             {{ symbol }}
        </b-tag>
        </span>
        <span v-else>
            All Symbols
        </span>
                <b-icon icon="menu-down"></b-icon>
            </button>
            <b-dropdown-item v-for="(symbol, index) in symbols" :key="index" :value="symbol" aria-role="listitem">
                <span>{{ symbol }}</span>
            </b-dropdown-item>
        </b-dropdown>
        </b-field>
                <span v-if="selectedOptions.length>=1"><a @click="resetFilter" class="selectDel delete"></a></span>
        </b-field>

        <!-- <span v-if="isMarketClosed" class="is-size-7 has-text-weight-bold has-text-danger">Market closed. Showing data for the previous business day <br /></span> -->

        <div v-if="data.length>=1" class="has-text-left">
 <b-collapse :open="false" aria-id="contentIdForA11y1">
            <button
                class="button is-light is-small"
                slot="trigger"
                aria-controls="contentIdForA11y1">Show / Hide Fields</button>
                 <div class="notification">
                <div class="content">

            <div class="block">
    
                <b-checkbox v-for="(column, index) in columnsVisible"
                 :key="index"
                 class="control" size="is-small" v-model="column.display">
                    {{ column.title }}
                </b-checkbox>
            </div>
        </div></div>
        </b-collapse>

        <b-table
            :data="data"
            :loading="loading"
            narrowed
            mobile-cards
            striped
            hoverable
            paginated
            pagination-size="is-small"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            >

            <template slot-scope="props">
                <b-table-column field="date" :label="columnsVisible['date'].title" :visible="columnsVisible['date'].display">
                    {{ props.row[0] }}
                </b-table-column>

                <b-table-column field="1" :label="columnsVisible['instrument_name'].title" :visible="columnsVisible['instrument_name'].display" centered>
                    <span class="tag" :class="type(props.row[1])">
                        {{ props.row[1] }}
                    </span>
                </b-table-column>

                <b-table-column field="2" :label="columnsVisible['symbol'].title" :visible="columnsVisible['symbol'].display"  centered sortable>
                     {{ props.row[2] }}
                </b-table-column>

                <b-table-column field="3" :label="columnsVisible['expiry_date'].title" :visible="columnsVisible['expiry_date'].display" sortable centered>
                    <!-- {{ props.row[3] ? new Date(props.row[3]).toLocaleDateString() : '' }} -->
                   <span class="tag is-success"> {{ props.row[3] }}</span>
                </b-table-column>

<b-table-column :label="columnsVisible['option_type'].title" :visible="columnsVisible['option_type'].display" field="4" sortable> {{props.row[4]}} </b-table-column>
<b-table-column :label="columnsVisible['strike_price'].title" :visible="columnsVisible['strike_price'].display" field="row[5]" numeric sortable> {{props.row[5]}} </b-table-column>
<b-table-column :label="columnsVisible['open'].title" :visible="columnsVisible['open'].display" field="6" numeric sortable> {{props.row[6]}} </b-table-column>
<b-table-column :label="columnsVisible['high'].title" :visible="columnsVisible['high'].display" field="7" numeric sortable> {{props.row[7]}} </b-table-column>
<b-table-column :label="columnsVisible['low'].title" :visible="columnsVisible['low'].display" field="8" numeric sortable> {{props.row[8]}} </b-table-column>
<b-table-column :label="columnsVisible['close'].title" :visible="columnsVisible['close'].display" field="9" numeric sortable> {{props.row[9]}} </b-table-column>
<b-table-column :label="columnsVisible['previous_close'].title" :visible="columnsVisible['previous_close'].display" field="10" numeric sortable> {{props.row[10]}} </b-table-column>
<b-table-column :label="columnsVisible['volume_in_lots'].title" :visible="columnsVisible['volume_in_lots'].display" field="11" numeric sortable> {{props.row[11]}} </b-table-column>
<b-table-column :label="columnsVisible['volume_in_000_s'].title" :visible="columnsVisible['volume_in_000_s'].display" field="12" numeric sortable> {{props.row[12]}} </b-table-column>
<b-table-column :label="columnsVisible['value_in_lakhs'].title" :visible="columnsVisible['value_in_lakhs'].display" field="13" numeric sortable> {{props.row[13]}} </b-table-column>
<b-table-column :label="columnsVisible['open_interest_in_lots'].title" :visible="columnsVisible['open_interest_in_lots'].display" field="14" numeric sortable> {{props.row[14]}} </b-table-column>
            </template>
        </b-table>
        </div>
        <div class="has-text-centered" v-else>
          <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="false"></b-loading>
          <b-notification
            type="is-warning"
            has-icon
            aria-close-label="Close notification"
            role="alert"
            :closable="false"
            >
            <span class="has-text-weight-bold">No data for the selected date</span><br />
          <span class="is-size-7">some of the possible reasons include<br />
          <div class="content has-text-left">
          <ul>
            <li>MCX bhavcopy not generated for the day yet. Please try later, after trading hours</li>
            <li>Market may have been closed, see <a class="has-text-info" href="https://www.mcxindia.com/market-operations/trading-survelliance/trading-holidays" target="_blank">Trading holidays</a> for more </li>
        </ul>
        </div>
        </span>
        </b-notification>

          <!-- <div class="notification has-text-left">
          <b-icon
                icon="alert"
                size="is-large"
                type="is-warning">
            </b-icon>
          <span class="has-text-weight-bold">No data for the selected date</span><br />
          <span class="is-size-7">it could be because of the following<br />
          <div class="content has-text-left">
          <ul>
            <li>Report not generated for the day, try later after trading hours</li>
            <li>Market may have been closed, see <a class="has-text-info" href="https://www.mcxindia.com/market-operations/trading-survelliance/trading-holidays" target="_blank">Trading holidays</a> for more </li>
        </ul>
        </div>
        </span>
          </div> -->
          </div>
          </div>
    </section>
</template>

<script>
import axios from "axios";

    export default {
        data() {
           const today = new Date()
            return {
                data: [],
                selectedOptions: [],
                date:'',
                unselectedDays:[0, 6],
                isMarketClosed: false,
                maxDate: new Date(),
                minDate: new Date(today.getFullYear() - 5, today.getMonth(),today.getDate()),
                curDate: new Date(),
                total: 0,
                loading: true,
                sortField: 'vote_count',
                sortOrder: 'desc',
                defaultSortOrder: 'desc',
                page: 1,
                perPage: 20,
                columnsVisible: {
                    date : { title:'Date', display:false },
                    instrument_name : { title:'Instrument', display:true },
                    symbol : { title:'Symbol', display:true },
                    expiry_date : { title:'Expiry Date', display:true },
                    option_type : { title:'Option Type', display:true },
                    strike_price : { title:'Strike Price', display:true },
                    open : { title:'Open', display:true },
                    high : { title:'High', display:true },
                    low : { title:'Low', display:true },
                    close : { title:'Close', display:true },
                    previous_close : { title:'Previous Close', display:true },
                    volume_in_lots : { title:'Volume (in lots)', display:true },
                    volume_in_000_s : { title:'Volume (in 000s)', display:true },
                    value_in_lakhs : { title:'Value (in lakhs)', display:true },
                    open_interest_in_lots : { title:'Open Interest (in lots)', display:true },
                },
                symbols: [
                    'ALUMINI',
                    'ALUMINIUM',
                    'BRASSPHY',
                    'CARDAMOM',
                    'CASTORSEED',
                    'COPPER',
                    'COTTON',
                    'CPO',
                    'CRUDEOIL',
                    'CRUDEOILM',
                    'GOLD',
                    'GOLDGUINEA',
                    'GOLDM',
                    'GOLDPETAL',
                    'LEAD',
                    'LEADMINI',
                    'MENTHAOIL',
                    'NATURALGAS',
                    'NICKEL',
                    'PEPPER',
                    'RBDPMOLEIN',
                    'SILVER',
                    'SILVERM',
                    'SILVERMIC',
                    'ZINC',
                    'ZINCMINI'
                ]
            }
        },
        methods: {
            /*
        * Load async data
        */
            getBhavCopy() {
              this.date = ("0" + this.curDate.getDate()).slice(-2)+'/'+("0" + (this.curDate.getMonth() + 1) ).slice(-2)+'/'+this.curDate.getFullYear();
                const params = [
                    `date=${this.date}`,
                    `symbol=${this.selectedOptions}`
                ].join('&')

                this.loading = true
                axios.get(`https://nitishraj.com/mcx.php?${params}`)
                    .then(({ data }) => {
                        // api.themoviedb.org manage max 1000 pages
                        this.data = []
                        if(data.length>=1){
                            data.forEach((item) => {
                            // item.release_date = item.release_date.replace(/-/g, '/')
                            this.data.push(item)
                            })
                          this.data.shift();
                        }
                        // let currentTotal = data.total_results
                        // if (data.total_results / this.perPage > 1000) {
                        //     currentTotal = this.perPage * 1000
                        // }
                        // this.total = currentTotal
                        
                        this.loading = false
                    })
                    .catch((error) => {
                        this.data = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            /*
        * Handle page-change event
        */
            onPageChange(page) {
                this.page = page
                this.getBhavCopy()
            },
            /*
        * Handle sort event
        */
            onSort(field, order) {
                this.sortField = field
                this.sortOrder = order
                this.getBhavCopy()
            },
            /*
        * Type style in relation to the value
        */
            type(value) {
                const number = parseFloat(value)
                if (number < 6) {
                    return 'is-danger'
                } else if (number >= 6 && number < 8) {
                    return 'is-warning'
                } else if (number >= 8) {
                    return 'is-success'
                }
            },

            weekend() {
                this.$buefy.snackbar.open({
                    type:'is-warning',
                    duration:6000,
                    position: 'is-top',
                    message:'<b>Market Closed</b><br />Fetching Data for the previous business day'
                })
            },

            resetFilter(){
                this.selectedOptions=[];
                this.getBhavCopy();
            }
        },
        filters: {
            /**
        * Filter to truncate string, accepts a length parameter
        */
            truncate(value, length) {
                return value.length > length
                    ? value.substr(0, length) + '...'
                    : value
            }
        },
        mounted() {
            var day = this.curDate.getDay();
            if(day==0){
                this.weekend()
                this.curDate = new Date(this.curDate.getFullYear(), this.curDate.getMonth(),this.curDate.getDate() - 2);
            }
            else if(day==6){
                this.weekend()
                this.curDate = new Date(this.curDate.getFullYear(), this.curDate.getMonth(),this.curDate.getDate() - 1);
            }
            this.getBhavCopy()
        }
    }
</script>
